<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        width="16" 
        height="16" 
        :fill="fillColor" 
        :class="svgClass" 
        viewBox="0 0 16 16"
    >
        <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>
    </svg>
</template>
  

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['fill', 'iconClass'])

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : 'w-5 h-5'
})

const fillColor = computed(() => {
    return props.fill ? props.fill : 'black'
})

</script>